import { Directive, Input, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[hide-header]',
  host: { '(ionScroll)': 'onContentScroll($event)' }
})
export class HideHeaderDirective {

  @Input("header") header: HTMLElement;
  @Input("fab_button") fab_button: HTMLElement;

  private headerHeight;
  private scrollContent;

  constructor(
    public element: ElementRef,
    public renderer: Renderer
  ) { }

  ngOnInit() {
    this.headerHeight = this.header.clientHeight;
    this.renderer.setElementStyle(this.header, 'webkitTransition', 'top 100ms');
    this.scrollContent = this.element.nativeElement.getElementsByClassName("scroll-content")[0];
    this.renderer.setElementStyle(this.scrollContent, 'webkitTransition', 'margin-top 100ms');
  }

  onContentScroll(event) {
    // TODO: esto debe ser bien probado antes de incluirlo
    // console.log(event.directionY, new Date().getTime())
    // if (event.directionY === 'down') {
    //   this.renderer.setElementStyle(this.header, "top", `-${this.headerHeight}px`);
    //   this.renderer.setElementStyle(this.scrollContent, "margin-top", "0px");
    // } else if (event.directionY === 'up') {
    //   this.renderer.setElementStyle(this.header, "top", "0px");
    //   this.renderer.setElementStyle(this.scrollContent, "margin-top", `${this.headerHeight}px`);
    // }

    if ((event.scrollTop - event.startY) > 124 && (event.scrollHeight - event.contentWidth) > 400 && event.directionY === 'down') {
      this.renderer.setElementStyle(this.header, "top", `-${this.headerHeight}px`);
      this.renderer.setElementStyle(this.scrollContent, "margin-top", "0px");
    } else if ((event.startY - event.scrollTop) > 124 && event.directionY === 'up') {
      this.renderer.setElementStyle(this.header, "top", "0px");
      this.renderer.setElementStyle(this.scrollContent, "margin-top", `${this.headerHeight + 10}px`);
    }
  }

}



// WEBPACK FOOTER //
// ./src/directives/hide-header/hide-header.ts